import { connect } from "react-redux";
import { PageFAQ } from "senac-components";
import {
  PageFAQDispatchProps,
  PageFAQStateProps,
  PageFAQProps,
} from "senac-components/dist/pages/Mobile/PageFAQ";
import { AppDispatch, RootState } from "../store";
import { commonSlice, userSlice } from "../store/reducers";
import { PageHeaderOptionItem } from "senac-components/dist/pages/Mobile/PageInterfaces";

import { PageFAQWeb } from "senac-components/dist/pages/Web/PageFAQ";

const mapState = (state: RootState) => {
  const authenticatedUser = state.userState.user != undefined;

  let result: PageFAQStateProps = {
    authenticatedUser,
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  const result: PageFAQDispatchProps = {
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: PageHeaderOptionItem) =>
      dispatch(commonSlice.actions.goToMyProfileOption(option)),
    onSelectedNavigationPageOption: (option) =>
      dispatch(commonSlice.actions.goToPage(option)),
  };

  return result;
};

const WPageFAQ = () => {
  const Mobile = connect(mapState, mapDispatch)(PageFAQ);
  const Web = connect(mapState, mapDispatch)(PageFAQWeb);
  if (window.innerWidth < 1024) return <Mobile />;
  return <Web />;
};

export { WPageFAQ };
